import React from 'react';
import SvgIcon from '../../../../utils/SvgIcon';

import { useJobsConfig } from '../../../../PortalJobListing/hooks/useJobsConfig';

const NextJobSummaryServiceStopped = () => {
  const { labels } = useJobsConfig();

  return (
    <div className="next-job-summary">
      <div className="next-job-summary__body">
        <div className="next-job-summary__header">
          <div className="next-job-summary__icon-container">
            <SvgIcon viewBox="0 0 40 40" iconName="service-stopped" className="next-job-summary__icon" />
          </div>

          <div className="next-job-summary__header-content">
            <div className="next-job-summary__title next-job-summary__title--service-stopped">
              {labels.serviceStoppedHeading}
            </div>
          </div>
        </div>

        <div className="next-job-summary__warning-alert">
          <div className="next-job-summary__warning-alert-icon">
            <SvgIcon
              viewBox="0 0 20 20"
              iconName="warning-triangle"
              className="next-job-summary__warning-alert-icon-svg"
            />
          </div>
          <div className="next-job-summary__warning-alert-content">
            <div className="next-job-summary__warning-alert-title">{labels.serviceStoppedSubHeading}</div>
            <div className="next-job-summary__warning-alert-text">{labels.serviceStoppedText}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextJobSummaryServiceStopped;
